module.exports = __webpack_public_path__ + "img/line2.579b4073.svg";